export default __webpack_public_path__ + "cfc56468bdc416bf4fcbabfd071b2029.svg";